/* eslint-disable import/no-unresolved,import/no-duplicates,import/extensions */
import { select } from 'redux-saga/effects';
import { remove } from 'lodash';
import { makeSelectStep2 } from 'containers/FastCover/Step2/selectors';
import { makeSelectStepAppsureBankDetails } from 'containers/FastCover/Appsure.StepBankDetails/selectors';
// import { makeSelectStep4 } from 'containers/FastCover/Step4/selectors';
import {
  makeSelectStepWhatHappened,
  makeSelectCountryList,
} from 'containers/FastCover/StepWhatHappened/selectors';
import { makeSelectStepCancellationAdditional } from 'containers/FastCover/StepCancellationAdditional/selectors';
import { makeSelectStepPersonalItems } from 'containers/FastCover/StepPersonalItems/selectors';
import { makeSelectStepOverseasMedical } from 'containers/FastCover/StepOverseasMedical/selectors';
import { makeSelectStepRentalVehicle } from 'containers/FastCover/StepRentalVehicle/selectors';
import { makeSelectStepSnowSports } from 'containers/FastCover/StepSnowSports/selectors';
import { makeSelectStepOther } from 'containers/FastCover/StepOther/selectors';
import { makeSelectStepDeclaration } from 'containers/FastCover/StepDeclaration/selectors';
import { makeSelectStepClaimSummary } from 'containers/FastCover/StepClaimSummary/selectors';
import { makeSelectStep16 } from 'containers/FastCover/Step16/selectors';
import { makeSelectStep17 } from 'containers/FastCover/Step17/selectors';
import { makeSelectStepTripCancellationAndTripInterruption } from 'containers/FastCover/StepTripCancellationAndTripInterruption/selectors';
import { makeSelectStepBaggageAndPersonalItems } from 'containers/FastCover/StepBaggageAndPersonalItems/selectors';
import { makeSelectStepMedicalExpenses } from 'containers/FastCover/StepMedicalExpenses/selectors';
import { makeSelectStepPaymentDetails } from 'containers/FastCover/StepPaymentDetails/selectors';
import { makeSelectMedicalExpenseStep } from 'containers/FastCover/Trawick.NationWide.MedicalExpenseStep/selectors';
import { makeSelectTripCancellationStep } from 'containers/FastCover/Trawick.NationWide.TripCancellationStep/selectors';
import { makeSelectTripDelayStep } from 'containers/FastCover/Trawick.NationWide.TripDelayStep/selectors';
import { makeSelectTripInterruptionStep } from 'containers/FastCover/Trawick.NationWide.TripInterruptionStep/selectors';
import { makeSelectPetMedicalStep } from 'containers/FastCover/Trawick.NationWide.PetMedicalStep/selectors';
import { makeSelectPersonalItemStep } from 'containers/FastCover/Trawick.NationWide.PersonalItemStep/selectors';
import { makeSelectPropertyDamageStep } from 'containers/FastCover/Trawick.NationWide.PropertyDamageStep/selectors';
import { makeSelectCollisionDamageStep } from 'containers/FastCover/Trawick.NationWide.CollisionDamageStep/selectors';
import { makeSelectAccidentalDeathAndDismembermentStep } from 'containers/FastCover/Trawick.NationWide.AccidentalDeathAndDismembermentStep/selectors';
import { makeSelectMissedConnectionStep } from 'containers/FastCover/Trawick.NationWide.MissedConnectionStep/selectors';
import { makeSelectSportsEquipmentStep } from 'containers/FastCover/Trawick.NationWide.SportsEquipmentStep/selectors';
import { makeSelectMedicalHardshipStep } from 'containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/selectors';
import { makeSelectJobLossHardshipStep } from 'containers/FastCover/Trawick.DuesProtect.JobLossHardshipStep/selectors';
import { makeSelectDisasterAssistanceHardshipStep } from 'containers/FastCover/Trawick.DuesProtect.DisasterAssistanceHardshipStep/selectors';
import { makeSelectMedicalExpenseCFStep } from 'containers/FastCover/Trawick.CFTripCan.MedicalExpense/selectors';
import { makeSelectMedicalExpenseZurichStep } from 'containers/FastCover/Trawick.Zurich.MedicalExpense/selectors';
import { makeSelectTripCancellationCFStep } from 'containers/FastCover/Trawick.CFTripCan.TripCancellationStep/selectors';
import { makeSelectStepTravelDelay } from 'containers/FastCover/StepTravelDelay/selectors';
import { makeSelectItineraryChange } from 'containers/FastCover/Trawick.CFTripCan.ItineraryChange/selectors';
import { makeSelectMedicalAndEvacuationSCTIStep } from 'containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/selectors';
import { makeSelectChangesToYourJourneySCTIStep } from 'containers/FastCover/Trawick.SCTI.ChangesToYourJourney/selectors';
import { makeSelectChangesToYourJourneyStep } from 'containers/FastCover/Trawick.ChangesToYourJourney/selectors';
import { makeSelectStepBaggageAndPersonalItemsStarr } from 'containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/selectors';
import { makeSelectStepOtherStarr } from 'containers/FastCover/Trawick.Starr.StepOther/selectors';
import { makeSelectCollisionDamageStarrStep } from 'containers/FastCover/Trawick.Starr.StepCollisionDamage/selectors';
import { makeSelectBaggageAndPersonalItemsSCTIStep } from 'containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/selectors';
import { makeSelectCashBankCardsTravelDocumentsAndPassportsStep } from 'containers/FastCover/Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/selectors';
import { makeSelectPersonalAccidentSCTIStep } from 'containers/FastCover/Trawick.SCTI.PersonalAccident/selectors';
import { makeSelectRentalVehicleExcessSCTIStep } from 'containers/FastCover/Trawick.SCTI.RentalVehicleExcess/selectors';
import { makeSelectStepSupportingDocuments } from 'containers/FastCover/StepSupportingDocuments/selectors';
import { makeSelectMedicalExpensesTugoStep } from 'containers/FastCover/Tugo.MedicalExpenses/selectors';
import { makeSelectStepOtherTugo } from '../Tugo.StepOther/selectors';
import { makeSelectBaseVictorsMedicalTugo } from '../Tugo.BaseVictorsMedical/selectors';
import { makeSelectStudentMedicalBenefitsTugo } from '../Tugo.StudentMedicalBenefits/selectors';
import { makeSelectTripInterruptionTugo } from '../Tugo.TripInterruption/selectors';
import { makeSelectStandardVTCMedicalBenefitsTugo } from '../Tugo.StandardVTCMedicalBenefits/selectors';
import { makeSelectADAndDBenefitsTugo } from '../Tugo.ADAndDBenefits/selectors';
// import { makeSelectStepBankDetails } from 'containers/FastCover/StepBankDetails/selectors';
import { makeSelectClaimTypes, makeSelectClaimList } from 'containers/ClaimList/selectors';
import step2Mapper from './step2DataMapper';
import stepAppsureBankDetailsMapper from './stepAppsureBankDetailsDataMapper';
// import step4Mapper from './step4DataMapper';
import stepWhatHappenedMapper from './stepWhatHappenedDataMapper';
import stepCancellationAdditionalMapper from './stepCancellationAdditionalDataMapper';
import stepPersonalItemsMapper from './stepPersonalItemsDataMapper';
import stepOverseasMedicalMapper from './stepOverseasMedicalDataMapper';
import stepRentalVehicleMapper from './stepRentalVehicleDataMapper';
import stepSnowSportsMapper from './stepSnowSportsDataMapper';
import stepOtherMapper from './stepOtherDataMapper';
import stepDeclarationMapper from './stepDeclarationDataMapper';
import stepClaimSummaryMapper from './stepClaimSummaryDataMapper';
import step16Mapper from './step16DataMapper';
import step17Mapper from './step17DataMapper';
import stepTripCancellationAndTripInterruptionMapper from './stepTripCancellationAndTripInterruption';
import stepBaggageAndPersonalItemsMapper from './stepBaggageAndPersonalItemsDataMapper';
import stepMedicalExpensesMapper from './stepMedicalExpensesDataMapper';
import stepPaymentDetailsMapper from './stepPaymentDetailsDataMapper';
import stepMedicalExpense from './stepMedicalExpenseDataMapper';
import stepTripCancellation from './stepTripCancellationDataMapper';
import stepTripDelay from './stepTripDelayDataMapper';
import stepTripInterruption from './stepTripInterruptionDataMapper';
import stepPetMedical from './stepPetMedicalDataMapper';
import stepPersonalItem from './stepPersonalItemDataMapper';
import stepPropertyDamage from './stepPropertyDamageDataMapper';
import stepCollisionDamage from './stepCollisionDamageDataMapper';
import stepAccidentalDeathAndDismemberment from './stepAccidentalDeathAndDismembermentDataMapper';
import stepMissedConnection from './stepMissedConnectionDataMapper';
import stepSportsEquipment from './stepSportsEquipmentDataMapper';
import stepMedicalHardship from './stepMedicalHardshipDataMapper';
import stepJobLossHardship from './stepJobLossHardshipDataMapper';
import stepDisasterAssistanceHardship from './stepDisasterAssistanceHardshipDataMapper';
import stepMedicalExpenseCF from './stepMedicalExpenseCFDataMapper';
import stepMedicalExpenseZurich from './stepMedicalExpenseZurichDataMapper';
import stepTripCancellationCF from './stepTripCancellationCFDataMapper';
import stepTravelDelay from './stepTravelDelayDataMapper';
import stepItineraryChange from './stepItineraryChangeDataMapper';
import medicalAndEvacuationSCTI from './stepMedicalAndEvacuationSCTIDataMapper';
import stepMedicalExpensesTugoMapper from './stepMedicalExpensesTugoDataMapper';
import changesToYourJourneySCTI from './stepChangesToYourJourneySCTIDataMapper';
import changesToYourJourney from './stepChangesToYourJourneyDataMapper';
import baggageAndPersonalItemsStarr from './stepBaggageAndPersonalItemsStarrDataMapper';
import otherDataStarr from './stepOtherDataStarrMapper';
import collisionDamageStarr from './stepCollisionDamageStarrDataMapper';
import stepSupportingDocuments from './stepSupportingDocumentsDataMapper';
import baggageAndPersonalItemsSCTI from './stepBaggageAndPersonalItemsSCTIDataMapper';
import cashBankCardsTravelDocumentsAndPassports from './stepCashBankCardsTravelDocumentsAndPassportsDataMapper';
import personalAccidentSCTI from './stepPersonalAccidentSCTIDataMapper';
import rentalVehicleExcessSCTI from './stepRentalVehicleExcessSCTIDataMapper';
import otherDataTugo from './stepOtherDataTugoMapper';
import baseVictorsMedicalTugo from './stepBaseVictorsMedicalTugoDataMapper';
import studentMedicalBenefitsTugo from './stepStudentMedicalBenefitsTugoDataMapper';
import tripCancellationTugo from './stepTripCancellationTugoDataMapper';
import stepTripInterruptionTugoMapper from './stepTripInterruptionTugoDataMapper';
import standardVTCMedicalBenefitsTugo from './stepStandardVTCMedicalBenefitsTugoDataMapper';
import stepADAndDTugoDataMapper from './stepADAndDTugoDataMapper';
import { listCodeForDuesProtect } from '../dataMapper/claimCodeMapper';
import { makeSelectIncidentDate } from '../../App/selectors';
import { makeSelectLoginInfo } from '../../Login/selectors';
import { makeSelectStepTripCancellationTugo } from '../Tugo.TripCancellation/selectors';
import { appConfig } from './../../../configureApp';
// import stepBankDetailsMapper from './stepBankDetailsDataMapper';

export function* map(selectedStep) {
  const showANZPayment = appConfig.showANZPayment;
  const isScti = appConfig.reactAppEnv === 'scti';
  const claimTypes = yield select(makeSelectClaimTypes());
  const defaultClaimCode = claimTypes.length > 0 ? claimTypes[0].claimCode : '';
  const step2Data = yield select(makeSelectStep2());
  const stepAppsureBankDetailsData = yield select(makeSelectStepAppsureBankDetails());
  // const step4Data = yield select(makeSelectStep4());
  const stepWhatHappenedData = yield select(makeSelectStepWhatHappened());
  // Logic for Dues Protect
  const list = (!!stepWhatHappenedData.selectedBenefits && typeof stepWhatHappenedData.selectedBenefits.toJS === 'function') ? stepWhatHappenedData.selectedBenefits.toJS() : (stepWhatHappenedData.selectedBenefits || []);
  const isVisibleDuesProtect = (list.filter((d) => ((listCodeForDuesProtect).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const incidentDate = yield select(makeSelectIncidentDate());
  const claim = yield select(makeSelectClaimList());
  const description = list.length > 0 ? list[0].description : '';
  const userInfo = yield select(makeSelectLoginInfo());

  const stepCancellationAdditionalData = yield select(makeSelectStepCancellationAdditional());
  const stepPersonalItemsData = yield select(makeSelectStepPersonalItems());
  const stepOverseasMedicalData = yield select(makeSelectStepOverseasMedical());
  const stepRentalVehicleData = yield select(makeSelectStepRentalVehicle());
  const stepSnowSportsData = yield select(makeSelectStepSnowSports());
  const stepOtherData = yield select(makeSelectStepOther());
  const stepDeclarationData = yield select(makeSelectStepDeclaration());
  const stepClaimSummaryData = yield select(makeSelectStepClaimSummary());
  const step16Data = yield select(makeSelectStep16());
  const step17Data = yield select(makeSelectStep17());
  const stepTripCancellationAndTripInterruptionData = yield select(makeSelectStepTripCancellationAndTripInterruption());
  const stepBaggageAndPersonalItemsData = yield select(makeSelectStepBaggageAndPersonalItems());
  const stepMedicalExpensesData = yield select(makeSelectStepMedicalExpenses());
  const stepPaymentDetailsData = yield select(makeSelectStepPaymentDetails());
  const stepMedicalExpenseData = yield select(makeSelectMedicalExpenseStep());
  const stepTripCancellationData = yield select(makeSelectTripCancellationStep());
  const stepTripDelayData = yield select(makeSelectTripDelayStep());
  const stepTripInterruptionData = yield select(makeSelectTripInterruptionStep());
  const stepPetMedicalData = yield select(makeSelectPetMedicalStep());
  const stepPersonalItemData = yield select(makeSelectPersonalItemStep());
  const stepPropertyDamageData = yield select(makeSelectPropertyDamageStep());
  const stepCollisionDamageData = yield select(makeSelectCollisionDamageStep());
  const stepAccidentalDeathAndDismembermentData = yield select(makeSelectAccidentalDeathAndDismembermentStep());
  const stepMissedConnectionData = yield select(makeSelectMissedConnectionStep());
  const stepSportsEquipmentData = yield select(makeSelectSportsEquipmentStep());
  const stepMedicalHardshipData = yield select(makeSelectMedicalHardshipStep());
  const stepJobLossHardshipData = yield select(makeSelectJobLossHardshipStep());
  const stepDisasterAssistanceHardshipData = yield select(makeSelectDisasterAssistanceHardshipStep());
  const stepMedicalExpenseCFData = yield select(makeSelectMedicalExpenseCFStep());
  const stepMedicalExpenseZurichData = yield select(makeSelectMedicalExpenseZurichStep());
  const stepTripCancellationCFData = yield select(makeSelectTripCancellationCFStep());
  const stepTravelDelayData = yield select(makeSelectStepTravelDelay());
  const stepItineraryChangeData = yield select(makeSelectItineraryChange());
  const stepMedicalAndEvacuationSCTIData = yield select(makeSelectMedicalAndEvacuationSCTIStep());
  const stepMedicalExpensesTugoData = yield select(makeSelectMedicalExpensesTugoStep());
  const stepChangesToYourJourneySCTIData = yield select(makeSelectChangesToYourJourneySCTIStep());
  const stepBaggageAndPersonalItemsSCTIData = yield select(makeSelectBaggageAndPersonalItemsSCTIStep());
  const stepCashBankCardsTravelDocumentsAndPassportsData = yield select(makeSelectCashBankCardsTravelDocumentsAndPassportsStep());
  const stepPersonalAccidentSCTIData = yield select(makeSelectPersonalAccidentSCTIStep());
  const stepRentalVehicleExcessSCTIData = yield select(makeSelectRentalVehicleExcessSCTIStep());
  const stepChangesToYourJourneyData = yield select(makeSelectChangesToYourJourneyStep());
  const stepBaggageAndPersonalItemsStarrData = yield select(makeSelectStepBaggageAndPersonalItemsStarr());
  const stepOtherStarrData = yield select(makeSelectStepOtherStarr());
  const stepCollisionDamageStarrData = yield select(makeSelectCollisionDamageStarrStep());
  const stepSupportingDocumentsData = yield select(makeSelectStepSupportingDocuments());
  const stepOtherTugoData = yield select(makeSelectStepOtherTugo());
  const stepBaseVictorsMedicalTugoData = yield select(makeSelectBaseVictorsMedicalTugo());
  const stepStudentMedicalBenefitsTugoData = yield select(makeSelectStudentMedicalBenefitsTugo());
  const stepTripCancellationTugoData = yield select(makeSelectStepTripCancellationTugo());
  const stepTripInterruptionTugoData = yield select(makeSelectTripInterruptionTugo());
  const stepStandardVTCMedicalBenefitsTugoData = yield select(makeSelectStandardVTCMedicalBenefitsTugo());
  const stepADAndDBenefitsTugoData = yield select(makeSelectADAndDBenefitsTugo());
  // const stepBankDetailsData = yield select(makeSelectStepBankDetails());
  const countryList = yield select(makeSelectCountryList());
  stepWhatHappenedData.country = countryList.filter(
    (item) => item.id === stepWhatHappenedData.country
  )[0];

  const mapperEntries = [
    { step: 2, mapper: step2Mapper, data: step2Data },
    { step: 3, mapper: stepAppsureBankDetailsMapper, data: stepAppsureBankDetailsData },
    // { step: 4, mapper: step4Mapper, data: step4Data },
    { step: 5, mapper: stepWhatHappenedMapper, data: stepWhatHappenedData },
    { step: 6, mapper: stepCancellationAdditionalMapper, data: stepCancellationAdditionalData },
    { step: 7, mapper: stepPersonalItemsMapper, data: stepPersonalItemsData },
    { step: 8, mapper: stepOverseasMedicalMapper, data: stepOverseasMedicalData },
    { step: 9, mapper: stepRentalVehicleMapper, data: stepRentalVehicleData },
    { step: 10, mapper: stepSnowSportsMapper, data: stepSnowSportsData },
    { step: 11, mapper: stepOtherMapper, data: stepOtherData },
    { step: 12, mapper: stepSupportingDocuments, data: stepSupportingDocumentsData },
    { step: 14, mapper: stepDeclarationMapper, data: stepDeclarationData },
    { step: 15, mapper: stepClaimSummaryMapper, data: stepClaimSummaryData },
    { step: 16, mapper: step16Mapper, data: step16Data },
    { step: 17, mapper: step17Mapper, data: step17Data },
    { step: 18, mapper: stepTripCancellationAndTripInterruptionMapper, data: stepTripCancellationAndTripInterruptionData },
    { step: 19, mapper: stepBaggageAndPersonalItemsMapper, data: stepBaggageAndPersonalItemsData },
    { step: 20, mapper: stepMedicalExpensesMapper, data: stepMedicalExpensesData },
    { step: 21, mapper: stepPaymentDetailsMapper, data: stepPaymentDetailsData },
    { step: 23, mapper: stepMedicalExpense, data: stepMedicalExpenseData },
    { step: 24, mapper: stepTripCancellation, data: stepTripCancellationData },
    { step: 25, mapper: stepPetMedical, data: stepPetMedicalData },
    { step: 26, mapper: stepPersonalItem, data: stepPersonalItemData },
    { step: 27, mapper: stepPropertyDamage, data: stepPropertyDamageData },
    { step: 28, mapper: stepCollisionDamage, data: stepCollisionDamageData },
    { step: 29, mapper: stepAccidentalDeathAndDismemberment, data: stepAccidentalDeathAndDismembermentData },
    { step: 30, mapper: stepTripDelay, data: stepTripDelayData },
    { step: 31, mapper: stepTripInterruption, data: stepTripInterruptionData },
    { step: 32, mapper: stepMissedConnection, data: stepMissedConnectionData },
    { step: 33, mapper: stepSportsEquipment, data: stepSportsEquipmentData },
    { step: 34, mapper: stepMedicalHardship, data: stepMedicalHardshipData },
    { step: 35, mapper: stepJobLossHardship, data: stepJobLossHardshipData },
    { step: 36, mapper: stepDisasterAssistanceHardship, data: stepDisasterAssistanceHardshipData },
    { step: 37, mapper: stepMedicalExpenseCF, data: stepMedicalExpenseCFData },
    { step: 38, mapper: stepTripCancellationCF, data: stepTripCancellationCFData },
    { step: 39, mapper: stepTravelDelay, data: stepTravelDelayData },
    { step: 40, mapper: stepItineraryChange, data: stepItineraryChangeData },
    { step: 41, mapper: medicalAndEvacuationSCTI, data: stepMedicalAndEvacuationSCTIData },
    { step: 42, mapper: changesToYourJourneySCTI, data: stepChangesToYourJourneySCTIData },
    { step: 43, mapper: baggageAndPersonalItemsSCTI, data: stepBaggageAndPersonalItemsSCTIData },
    { step: 44, mapper: personalAccidentSCTI, data: stepPersonalAccidentSCTIData },
    { step: 45, mapper: rentalVehicleExcessSCTI, data: stepRentalVehicleExcessSCTIData },
    { step: 46, mapper: cashBankCardsTravelDocumentsAndPassports, data: stepCashBankCardsTravelDocumentsAndPassportsData },
    { step: 47, mapper: changesToYourJourney, data: stepChangesToYourJourneyData },
    { step: 48, mapper: stepMedicalExpenseZurich, data: stepMedicalExpenseZurichData },
    { step: 49, mapper: baggageAndPersonalItemsStarr, data: stepBaggageAndPersonalItemsStarrData },
    { step: 50, mapper: otherDataStarr, data: stepOtherStarrData },
    { step: 51, mapper: collisionDamageStarr, data: stepCollisionDamageStarrData },
    { step: 52, mapper: stepMedicalExpensesTugoMapper, data: stepMedicalExpensesTugoData },
    { step: 53, mapper: otherDataTugo, data: stepOtherTugoData },
    { step: 54, mapper: baseVictorsMedicalTugo, data: stepBaseVictorsMedicalTugoData },
    { step: 55, mapper: studentMedicalBenefitsTugo, data: stepStudentMedicalBenefitsTugoData },
    { step: 56, mapper: tripCancellationTugo, data: stepTripCancellationTugoData },
    { step: 57, mapper: stepTripInterruptionTugoMapper, data: stepTripInterruptionTugoData },
    { step: 58, mapper: standardVTCMedicalBenefitsTugo, data: stepStandardVTCMedicalBenefitsTugoData },
    { step: 59, mapper: stepADAndDTugoDataMapper, data: stepADAndDBenefitsTugoData },
    // { step: 22, mapper: stepBankDetailsMapper, data: stepBankDetailsData },
  ];
  if (selectedStep.indexOf(6) < 0) {
    remove(mapperEntries, (x) => x.step === 6);
  }
  if (selectedStep.indexOf(7) < 0) {
    remove(mapperEntries, (x) => x.step === 7);
  }
  if (selectedStep.indexOf(8) < 0) {
    remove(mapperEntries, (x) => x.step === 8);
  }
  if (selectedStep.indexOf(9) < 0) {
    remove(mapperEntries, (x) => x.step === 9);
  }
  if (selectedStep.indexOf(10) < 0) {
    remove(mapperEntries, (x) => x.step === 10);
  }
  if (selectedStep.indexOf(11) < 0) {
    remove(mapperEntries, (x) => x.step === 11);
  }
  if (showANZPayment) {
    remove(mapperEntries, (x) => x.step === 21);
  }
  const apiData = mapToParentSection(mapperEntries, isVisibleDuesProtect, incidentDate, claim.city);
  const isMapQuestion = isScti === false;//for SCTI, we don't need to map questions
  apiData.questions = isMapQuestion ? mapToQuestions(mapperEntries, defaultClaimCode, isVisibleDuesProtect) : [];
  apiData.expenses = mapToExpenses(mapperEntries, userInfo, stepWhatHappenedData, description);
  return apiData;
}

function mapToParentSection(mapperEntries, isVisibleDuesProtect, incidentDate, city) {
  // mapperEntries contains individual entry of
  // { dataMapper, wizardStepData }
  // we need to loop through each individual entry
  // and merge all the parent section data into a single object
  let parentSection = {};
  mapperEntries.forEach((entry) => {
    const { mapper, data } = entry;
    if (entry.step === 5) {
      const sectionData = mapper.mapToParentSection(data, isVisibleDuesProtect, incidentDate, city);
      parentSection = Object.assign(parentSection, sectionData);
    } else {
      const sectionData = mapper.mapToParentSection(data);
      parentSection = Object.assign(parentSection, sectionData);
    }
  });
  return parentSection;
}

function mapToQuestions(mapperEntries, defaultClaimType, isVisibleDuesProtect) {
  // mapperEntries contains individual entry of
  // { dataMapper, wizardStepData }
  // we need to loop through each individual entry
  // and merge all the question section data into an array that contains
  // all questions
  let allQuestions = [];
  mapperEntries.forEach((entry) => {
    const { mapper, data } = entry;
    if (entry.step === 5) {
      const stepQuestions = mapper.mapToQuestionnaire(data, defaultClaimType, isVisibleDuesProtect);
      allQuestions = allQuestions.concat(stepQuestions);
    } else {
      const stepQuestions = mapper.mapToQuestionnaire(data, defaultClaimType);
      allQuestions = allQuestions.concat(stepQuestions);
    }
  });
  return allQuestions;
}

function mapToExpenses(mapperEntries, userInfo, stepWhatHappenedData, description) {
  // mapperEntries contains individual entry of
  // { dataMapper, wizardStepData }
  // we need to loop through each individual entry
  // and merge all the expense section data into an array that contains
  // all expenses
  let allExpenses = [];
  mapperEntries.forEach((entry) => {
    const { mapper, data } = entry;
    const stepExpenses = mapper.mapToExpenses(data, userInfo, stepWhatHappenedData, description);
    allExpenses = allExpenses.concat(stepExpenses);
  });
  return allExpenses;
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/apiContractMapper.js